<script lang="ts">
    import { t } from '../lib/i18n/t';

    function reload() {
        window.location.reload()
    }
</script>

<div class="bno-container bno-container--centered">
    <div class="bno-container__content">
        <p>
            {t('error.rezervacniFormularSeNepodariloNacist')}
            <br/>
            {t('error.zkusteToProsimPozdeji')}
        </p>
        <button class="bno-button bno-button--primary" on:click={reload}>
            {t('error.obnovitStranku')}
        </button>
    </div>
</div>
